/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align */

import { WindowType       } from './window';
import { DocumentMetadata } from './document.metadata';
import {isset} from "@/util/util";

/**
 *
 * @class StringLineViewerMetadata
 *
 * @brief meta data (input/output pair) for string line viewer
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class StringLineViewerMetadata extends DocumentMetadata {

  /* the input scenario */
  public input:  string = '';

  /* the resulting simulation output (train movements) */
  public result: string = '';

  /*
   * how to treat the input scenario and movement values; as blob keys ('blob')
   * or as the actual content of the scenario and movement files. ('direct')
   */
  public mode: string   = 'blob';

  /* human-readable name for the scenario */
  public label: string  = '';

  /** standard constructor */
  constructor(
    id:          string = '',
    title:       string = '',
    scenarioKey: string = '',
    resultKey:   string = '',
    mode:        string = 'blob',
    label:       string = '',
    icon:        string = '<i class="fas fa-train"></i>',
    type:        WindowType = WindowType.StringLineViewer
  ) {

    super(id, title, icon, type);

    this.input  = scenarioKey;
    this.result = resultKey;
    this.mode   = mode;
    this.label  = label;
  }

  /** convert this element to a simplified form that can be easily serialized */
  public node(init?: any) {

    return super.node({input: this.input, result: this.result, mode: this.mode, label: this.label});
  }

  /** initialize this element given the data in the simplified node object */
  public fromNode(node: any): void {

    super.fromNode(node);

    this.input  = node.input;
    this.result = node.result;
    this.mode   = 'blob';
    this.label  = '';

    if (isset(node.mode)) {

      this.mode = node.mode;
    }

    if (isset(node.label)) {

      this.label = node.label;
    }
  }
}
